import * as classNames from 'classnames'
import * as React from 'react'
import { Link } from 'react-router-dom'

import { makeLink, parseLocation } from '../../../common/utils/urlHelper'
import { getConfigBySite } from '../../../config/sites'
import GridIcon from '../icons/grid'
import ListIcon from '../icons/list'

interface IProps {
  currentSite: string
  location: any
  currentView: string
}

interface IViewOption {
  value: string
  label: string
}

const LayoutSwitcher = ({ currentSite, location, currentView }: IProps) => {
  const itemViews: IViewOption[] =
    getConfigBySite(currentSite, 'ui.item_list_views') || []
  const parsedLocation = parseLocation(location)

  if (itemViews.length <= 1) {
    return null
  }

  return (
    <div className="search-facet-layout-switcher">
      <div className="btn-group">
        {itemViews.map((availableView, index) => {
          const nextQuery = {
            ...parsedLocation,
            view: availableView.value
          }
          const className = classNames('btn-search-switch', {
            'is-active': currentView === availableView.value
          })
          const Icon =
            availableView.value === 'grid' ? (
              <GridIcon title="Grid" />
            ) : (
              <ListIcon title="List" />
            )
          return (
            <Link to={makeLink(nextQuery)} className={className} key={index}>
              {Icon}
            </Link>
          )
        })}
      </div>
    </div>
  )
}

export default LayoutSwitcher



// WEBPACK FOOTER //
// ./client/components/layoutSwitcher/index.tsx